var _circle, _rect, _rect2, _circle2, _circle3, _path, _path2, _path3, _path4, _path5, _circle4, _path6, _path7, _path8, _path9, _rect3, _rect4, _circle5, _circle6, _path10, _path11, _circle7, _path12, _path13, _rect5, _ellipse, _rect6, _ellipse2, _path14, _path15, _path16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLandingGraphic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 465 168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 389.294,
    cy: 83.289,
    r: 62.5,
    transform: "rotate(-13.414 389.294 83.289)",
    fill: "#F2F7FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 9.29375,
    height: 1.53576,
    rx: 0.767879,
    transform: "matrix(-0.985083 -0.172077 -0.172077 0.985083 406.529 79.6871)",
    fill: "#1778E1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 9.29375,
    height: 1.53576,
    rx: 0.767879,
    transform: "matrix(-0.993312 0.115458 0.115458 0.993312 389.981 77.8831)",
    fill: "#1778E1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 1.72344,
    transform: "matrix(-0.999617 -0.0276766 -0.0276766 0.999617 400.322 85.9278)",
    fill: "#1778E1"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 1.72344,
    transform: "matrix(-0.999617 -0.0276766 -0.0276766 0.999617 386.54 85.5462)",
    fill: "#1778E1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M393.899 86.6121L395.657 89.5883C396.237 90.5707 395.879 91.8514 394.796 92.2097C393.582 92.6114 392.242 92.83 391.525 92.2932",
    stroke: "#1778E1",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M397.59 96.4473C396.107 97.4968 392.069 98.9118 387.782 96.1758",
    stroke: "#1778E1",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M387.782 96.1758C388.085 98.3653 389.569 102.55 393.08 101.775C396.591 101 397.55 97.9003 397.59 96.4473",
    stroke: "#1778E1",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M411.44 68.8403C412.42 81.5904 410.505 102.621 403.786 108.978C396.923 115.472 385.483 113.561 378.995 111.564C372.507 109.566 369.319 106.57 366.584 100.315C363.849 94.0591 361.889 99.1596 357.311 93.8781C353.436 89.4087 353.153 86.4927 355.856 80.7513C358.304 75.5532 366.551 75.2312 368.822 85.109",
    stroke: "#1778E1",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M411.441 68.8402C407.725 71.7666 397.766 76.9678 387.66 74.3615C377.554 71.7552 370.674 80.9192 368.73 85.4699C367.859 81.9318 365.868 77.7568 360.67 77.6129C357.401 77.5224 354.468 82.7728 354.304 84.3434C347.442 82.6994 338.149 76.9894 350.145 63.8715C365.404 47.1852 386.915 56.1771 394.942 47.6631C407.301 34.5552 430.034 40.6374 426.646 57.9923C423.257 75.3471 445.002 90.8533 433.289 106.887C423.919 119.714 425.081 127.623 426.834 129.973",
    stroke: "#1778E1",
    strokeWidth: 2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 239.504,
    cy: 83.4996,
    r: 60,
    transform: "rotate(17.201 239.504 83.4996)",
    fill: "#CADDFD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M217.494 121.593C208.986 112.286 208.549 83.6011 211.204 66.4327C262.57 62.105 270.238 82.2638 267.651 92.8841C271.77 79.7401 282.985 81.0308 285.786 88.3251C288.879 96.3818 288.192 100.302 282.445 105.955C275.654 112.634 273.508 105.522 269.131 113.712C264.754 121.902 260.095 125.63 251.04 127.663C241.984 129.696 226.183 131.098 217.494 121.593Z",
    fill: "#F2F7FF",
    stroke: "#1778E1",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M194.953 67.5931C191.066 60.8926 192.32 55.6567 195.679 52.5475C197.764 50.6182 200.971 51.1201 203.578 49.9945C205.506 49.1624 207.667 46.6475 214.696 39.6007C225.97 28.2986 254.246 52.1427 257.884 56.1275C261.523 60.1124 276.139 60.0932 282.467 71.8258C287.53 81.2119 271.196 92.4583 265.198 100.294C263.953 89.061 253.833 91.414 241.925 84.1345C227.041 75.0351 231.472 69.3594 224.766 69.035C216.204 68.6209 211.723 74.1994 210.096 76.1521C207.475 77.5488 200.045 76.3712 194.953 67.5931Z",
    fill: "#185888",
    stroke: "#185888",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M226.205 108.826C228.411 110.654 234.589 113.362 241.655 109.574",
    stroke: "#1778E1",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M241.655 109.574C240.917 112.979 238.084 119.381 232.657 117.742C227.229 116.103 226.094 111.115 226.205 108.826",
    stroke: "#1778E1",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 214.412,
    y: 83.5563,
    width: 14.653,
    height: 2.42135,
    rx: 1.21068,
    transform: "rotate(1.48126 214.412 83.5563)",
    fill: "#1778E1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 238.885,
    y: 85.4114,
    width: 14.653,
    height: 2.42135,
    rx: 1.21068,
    transform: "rotate(15.5274 238.885 85.4114)",
    fill: "#1778E1"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 223.098,
    cy: 92.777,
    r: 2.71726,
    transform: "rotate(2.769 223.098 92.777)",
    fill: "#1778E1"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 244.81,
    cy: 93.8271,
    r: 2.71726,
    transform: "rotate(2.769 244.81 93.8271)",
    fill: "#1778E1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M233.113 94.6216L229.302 100.081C228.649 101.016 228.909 102.312 229.933 102.814C232.009 103.833 234.732 104.75 236.165 103.837",
    stroke: "#1778E1",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M275.756 93.1188C277.796 94.5316 280.634 98.1946 275.658 101.543",
    stroke: "#1778E1",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 83.7629,
    cy: 83.763,
    r: 60,
    transform: "rotate(21.087 83.7629 83.763)",
    fill: "#FFE5DA"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2842 103.24C65.8543 95.7786 62.7817 70.3695 63.5343 54.8885C108.77 46.2417 108.544 54.1503 107.239 63.8152C109.67 51.7678 111.326 63.7112 114.497 69.9209C117.999 76.7797 121.747 84.4145 117.17 89.9674C115.835 91.5871 115.233 92.3848 114.989 92.7484C114.566 93.3795 115.22 92.7036 114.989 92.7484C114.814 92.7824 114.129 93.2308 112.079 94.9779C104.388 101.532 103.775 103.453 96.6777 107.737C90.3669 111.545 82.7142 110.701 74.2842 103.24Z",
    fill: "white",
    stroke: "#E85319",
    strokeWidth: 2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0045 84.8339L82.6684 89.0647C82.1169 90.0635 82.512 91.3274 83.5934 91.6914C85.2403 92.2458 87.2016 92.6062 88.1713 91.8345",
    stroke: "#E85319",
    strokeWidth: 2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 90.4641,
    y: 72.6325,
    width: 11.5978,
    height: 1.9165,
    rx: 0.958249,
    transform: "rotate(6.6941 90.4641 72.6325)",
    fill: "#E85319"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 95.1321,
    cy: 80.864,
    rx: 2.15071,
    ry: 2.15071,
    transform: "rotate(-3.24743 95.1321 80.864)",
    fill: "#E85319"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 71.3235,
    y: 76.4624,
    width: 11.5978,
    height: 1.9165,
    rx: 0.958249,
    transform: "rotate(-12.9168 71.3235 76.4624)",
    fill: "#E85319"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 77.7471,
    cy: 81.8504,
    rx: 2.15071,
    ry: 2.15071,
    transform: "rotate(-3.24743 77.7471 81.8504)",
    fill: "#E85319"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9062 95.3157C83.7943 96.5711 88.8822 98.19 94.1301 94.6221",
    stroke: "#E85319",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1301 94.6221C93.8315 97.3642 92.1323 102.638 87.7244 101.798C83.3165 100.958 82.009 97.1266 81.9062 95.3157",
    stroke: "#E85319",
    strokeWidth: 2
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8152 56.3754C91.1396 69.4231 80.1352 70.3654 70.6695 78.9086C66.094 83.1438 86.2163 101.413 75.5296 117.082C71.272 124.459 40.2356 117.528 37.0286 107.772C33.0198 95.5757 52.4415 90.1389 55.3261 82.5212C58.2107 74.9035 50.6615 58.7672 71.4958 45.9899C92.3302 33.2126 112.231 47.8198 114.821 64.2374C117.411 80.655 124.896 81.0585 130.341 103.94C134.696 122.245 107.973 121.584 103.021 111.162C96.0277 106.01 115.97 86.1325 106.588 83.2128C99.8354 81.1113 93.9041 47.8961 92.8152 56.3754Z",
    fill: "#FBBBA0",
    stroke: "#E85319",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingGraphic);
export default __webpack_public_path__ + "static/media/landing-graphic.26f95320.svg";
export { ForwardRef as ReactComponent };